import React, { useState } from 'react';
import logo from "../../assets/images/logo.png";

const PrivacyPolicy = () => {
    const [activeTab, setActiveTab] = useState('Privacy Policy');
    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
    };
    return (
        <div className="min-h-screen bg-white py-12 px-6">
            <div className="max-w-screen-2xl mx-auto">
                {}
                <div className="flex justify-center mb-8">
                    <a href="/"><img src={logo} className="w-[112px] lg:w-[140px] h-auto" alt="Selzor Logo" /></a>
                </div>

                {}
                <div className="flex flex-col items-center">
                    <ul className="mb-6 flex flex-wrap justify-center gap-6 border-b border-gray-200 pb-4">
                        <li>
                            {}
                            <button
                                onClick={() => handleTabClick('About Selzor')}
                                className={`text-base hover:text-[#1a9588] transition font-medium ${activeTab === 'About Selzor' ? 'text-[#1a9588]' : 'text-gray-600'}`}
                            >
                                About Selzor
                            </button>
                        </li>
                        <li>
                            <button
                                onClick={() => handleTabClick('Privacy Policy')}
                                className={`text-base hover:text-[#1a9588] transition font-medium ${activeTab === 'Privacy Policy' ? 'text-[#1a9588]' : 'text-gray-600'}`}
                            >
                                Privacy Policy
                            </button>
                        </li>
                        <li>
                            <button
                                onClick={() => handleTabClick('Refund & Cancellation Policy')}
                                className={`text-base hover:text-[#1a9588] transition font-medium ${activeTab === 'Refund & Cancellation Policy' ? 'text-[#1a9588]' : 'text-gray-600'}`}
                            >
                                Refund & Cancellation Policy
                            </button>
                        </li>
                        <li>
                            <button
                                onClick={() => handleTabClick('Terms of Service')}
                                className={`text-base hover:text-[#1a9588] transition font-medium ${activeTab === 'Terms of Service' ? 'text-[#1a9588]' : 'text-gray-600'}`}
                            >
                                Terms of Service
                            </button>
                        </li>
                        <li>
                            <button
                                onClick={() => handleTabClick('Disclaimer')}
                                className={`text-base hover:text-[#1a9588] transition font-medium ${activeTab === 'Disclaimer' ? 'text-[#1a9588]' : 'text-gray-600'}`}
                            >
                                Disclaimer
                            </button>
                        </li>
                    </ul>

                    {}
                    {}
                    <div className="w-full md:w-4/5 text-justify">
                        {activeTab === 'About Selzor' && (
                            <div className="text-justify">
                                <h2 className="text-2xl font-semibold text-gray-600 mb-4 text-start">
                                About Selzor
                                </h2>

                                <div className="space-y-4 text-gray-700 leading-relaxed">
                                <p>
                                    <span className="font-bold">Selzor</span> is a dedicated and secure{' '}
                                    <span className="font-semibold">B2B ordering platform</span> that simplifies the way{' '}
                                    <span className="font-semibold">Brands, Distributors, Wholesalers, Dealers,</span> and{' '}
                                    <span className="font-semibold">Retailers</span> interact within the supply chain. Designed
                                    for professional business use, Selzor offers a seamless digital experience to automate order
                                    placement across multiple tiers of distribution.
                                </p>

                                <p>
                                    Offered as a hosted solution under the <span className="font-semibold">SaaS (Software as a Service)</span> model, Selzor is accessible via the secure browser-based web application at{' '}
                                    <a
                                    href="https://b2b.selzor.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                    >
                                    https://b2b.selzor.com/
                                    </a>{' '}
                                    as well as through the Selzor Mobile App, available for download on both{' '}
                                    <span className="font-semibold">Android</span> and <span className="font-semibold">iOS</span> devices.
                                </p>

                                <p>
                                    For <span className="font-semibold">Manufacturers and Traders</span>, Selzor builds a customized online and mobile product catalogue, enabling a user-friendly way for their authorized{' '}
                                    <span className="font-semibold">Distributors and Dealers</span> to place purchase orders. These orders are submitted digitally and recorded within the system for further processing by the supplier.
                                </p>

                                <p>
                                    <span className="font-semibold">Important Privacy Note:</span> Selzor is strictly an{' '}
                                    <span className="font-semibold">order automation tool</span> - it does <span className="font-semibold">not</span> include or process any{' '}
                                    <span className="font-semibold">inventory tracking</span>, <span className="font-semibold">payment processing</span>, or <span className="font-semibold">checkout functionalities</span>. This ensures that no sensitive financial or inventory data is collected, stored, or transmitted through the Selzor platform. All orders are managed directly between the business entities involved.
                                </p>

                                <p>
                                    The Selzor platform is offered as a <span className="font-semibold">paid service</span> to
                                    Manufacturers and Traders who wish to receive and manage orders online. However, it remains{' '}
                                    <span className="font-semibold">entirely free</span> for their buyers - including all
                                    Distributors and Dealers - who wish to place orders through the platform.
                                </p>

                                <p>
                                    Selzor respects your data and privacy. The platform is designed with business confidentiality
                                    and operational transparency in mind, ensuring that your information is never misused,
                                    shared, or sold to any third parties.
                                </p>
                                </div>
                            </div>
                        )}


                        {activeTab === 'Privacy Policy' && (
                            <div className="text-justify mt-8">
                                <h2 className="text-2xl font-semibold text-gray-600 mb-4 text-start">Privacy Policy</h2>

                                <div className="text-gray-700 leading-relaxed space-y-4">
                                <p>
                                    <span className="font-semibold">Selzor</span> respects your privacy and is committed to safeguarding the personal information you share with us. This policy outlines how we handle the data collected through our services. By accessing or using the Selzor Web or Mobile App, you consent to the practices described below.
                                </p>

                                <h3 className="text-lg font-semibold text-gray-800">Visitor Information</h3>
                                <p>
                                    When you visit the Selzor website or web application, certain data such as browser type, referring site, and approximate geographic location may be logged. This information may be analyzed in aggregate form and is never shared in a personally identifiable manner.
                                </p>
                                <p>
                                    If authenticated, some data may be linked to your email, IP address, or mobile number. However, such personally identifiable data is never disclosed or published publicly.
                                </p>

                                <h3 className="text-lg font-semibold text-gray-800">Use of Collected Personal Information</h3>
                                <p>
                                    When you register with Selzor, we may collect your name, mobile number, email address, and country. This information is used solely to provide our services and maintain your account.
                                </p>
                                <p>
                                    Information related to your buyers, suppliers, or internal records (e.g., product data, order history, contact lists) remains confidential and is never disclosed to third parties.
                                </p>

                                <h3 className="text-lg font-semibold text-gray-800"> Payment Details</h3>
                                <p>
                                    For credit card transactions, payments may be processed through a secure third-party vendor such as PayPal. Selzor does not store or access your credit card information at any point.
                                </p>

                                <h3 className="text-lg font-semibold text-gray-800">Data Protection</h3>
                                <p>
                                    Access to your personal data is limited to authorized Selzor staff and affiliates, strictly on a need-to-know basis. External service providers may be used for hosting and technical services, and they are required to follow industry-standard security practices.
                                </p>
                                <p>
                                    Selzor may disclose data when required by law or legal process, or to protect the rights and safety of our users and platform.
                                </p>
                                <p>
                                    Feedback and correspondence shared with us may be published only with appropriate anonymity or for support reference purposes.
                                </p>

                                <h3 className="text-lg font-semibold text-gray-800">Data Security Measures</h3>
                                <p>
                                    Selzor implements reasonable safeguards to prevent unauthorized access, misuse, or modification of your data. Any shared data with third parties will be handled with equivalent or greater protection standards.
                                </p>
                                <p>
                                    If Selzor undergoes a merger or acquisition, your data may be transferred under the terms of this privacy policy, and you will be notified of any policy changes.
                                </p>

                                <h3 className="text-lg font-semibold text-gray-800">Cookies</h3>
                                <p>
                                    Our platform uses cookies to improve your user experience. These small files are stored in your browser and help us recognize repeat visits, retain session details, and save preferences.
                                </p>
                                <p>
                                    You may disable cookies via your browser settings, but some features may not function correctly without them.
                                </p>

                                <h3 className="text-lg font-semibold text-gray-800">Accessing or Deleting Your Information</h3>
                                <p>
                                    You may update your personal information at any time by logging into the Selzor Web or Mobile App (<a href="https://b2b.selzor.com/" className="text-blue-600 underline">https://b2b.selzor.com/</a>).
                                </p>
                                <p>
                                    If you wish to have your data permanently deleted, please contact us. We will process the deletion request unless certain information must be retained to fulfill our service obligations.
                                </p>

                                <h3 className="text-lg font-semibold text-gray-800"> Contact Us</h3>
                                <p>
                                    For any questions or concerns regarding this policy, feel free to reach out:
                                </p>
                                <p className="pl-4">
                                    <span className="font-semibold">Email:</span> <span className="text-blue-600">support@selzor.com</span>
                                </p>

                                <h3 className="text-lg font-semibold text-gray-800"> Policy Updates</h3>
                                <p>
                                    Selzor may revise this policy periodically. Users are encouraged to review this page regularly. Your continued use of our platform indicates your acceptance of any updated terms.
                                </p>

                                <p className="text-sm text-gray-500 italic mt-6">
                                    Last updated: <span className="font-semibold">{new Date().toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
                                </p>
                                </div>
                            </div>
                        )}


                        {activeTab === 'Refund & Cancellation Policy' && (
                            <div className="text-justify mt-8">
                                <h2 className="text-2xl font-semibold text-gray-600 mb-4 text-start">
                                Refund & Cancellation Policy
                                </h2>

                                <div className="space-y-4 text-gray-700 leading-relaxed">
                                <p>
                                    <span className="font-bold">Selzor</span> provides ample opportunity for potential customers
                                    to evaluate the service through a <span className="font-semibold">Free Account</span>{' '}
                                    before making any purchase or payment decision.
                                </p>

                                <p>
                                    <span className="font-semibold">Refund Policy:</span> Selzor has no obligation to issue
                                    refunds once a payment has been processed. Any refund, if provided, will be granted solely
                                    at <span className="font-bold">Selzor’s discretion</span>. Please note that{' '}
                                    <span className="font-semibold">payments are non-transferable</span> and cannot be shifted to
                                    another account under any circumstances.
                                </p>

                                <p>
                                    <span className="font-semibold">Cancellation Policy:</span> There is{' '}
                                    <span className="font-semibold">no option to cancel</span> your account during the active
                                    service period. The service will automatically expire at the end of the current plan if not
                                    renewed. No automatic charges or renewals are applied.
                                </p>

                                <p className="text-sm text-gray-500 italic">
                                    Last updated:{' '}
                                    <span className="font-semibold">
                                    {new Date().toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'long',
                                        year: 'numeric',
                                    })}
                                    </span>
                                </p>
                                </div>
                            </div>
                            )}


                        {activeTab === 'Terms of Service' && (
                            <div className="text-justify mt-8">
                                <h2 className="text-2xl font-semibold text-gray-600 mb-4 text-start">
                                Terms of Service
                                </h2>

                                <div className="space-y-6 text-gray-700 leading-relaxed">
                                <div>
                                    <p>
                                    <span className="font-bold">THIS IS AN AGREEMENT</span> between you or the entity that you
                                    represent and <span className="font-bold">Selzor</span>, governing your use of Selzor – a
                                    seamless B2B ordering platform for web and mobile.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Acceptance of the Terms</h3>
                                    <p>
                                    You must be of legal age to enter into a binding agreement in order to accept the Terms.
                                    If you do not agree to the Terms, do not use our service. You can accept the Terms by
                                    checking a checkbox, clicking a button indicating your acceptance, or by actually using
                                    the service.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Description of Service</h3>
                                    <p>
                                    <span className="font-bold">Selzor</span> is a seamless B2B ordering platform for{' '}
                                    <span className="font-semibold">Brands, Distributors, Wholesalers, Dealers,</span> and{' '}
                                    <span className="font-semibold">Retailers</span>. It is offered as a hosted service (SaaS
                                    model) and can be accessed via the Selzor web app at{' '}
                                    <a
                                        href="https://b2b.selzor.com/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-600 underline"
                                    >
                                        https://b2b.selzor.com/
                                    </a>{' '}
                                    or the Selzor Mobile App (available for both Android and iOS). This service does not
                                    include internet access, which must be obtained separately.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Use of Service</h3>
                                    <p>
                                    Selzor grants you a <span className="font-semibold">non-exclusive, non-transferable, non-sub-licensable</span>, and
                                    limited right to access and use the service through the web or mobile app, subject to
                                    these Terms.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Activation of Service</h3>
                                    <p>
                                    Account activation occurs immediately after sign-up. In rare cases, verification codes (via
                                    mobile or email) may be delayed. We ask for your patience in such cases. Premium features
                                    are activated immediately upon payment. If not, please allow 24 working hours for the
                                    changes to reflect. <span className="font-semibold">There is NO recurring billing</span> under premium plans. Upon expiration,
                                    plans must be renewed manually.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Access of Service</h3>
                                    <p>
                                    You can access the service using the login credentials you set during sign-up. The Selzor
                                    Web App is optimized for the latest versions of Google Chrome, Firefox, and Safari on
                                    Windows, macOS, and Linux. Enable JavaScript and cookies for the best experience. Minimum
                                    mobile app requirements: <span className="font-semibold">iOS 8+</span> and{' '}
                                    <span className="font-semibold">Android 4.4.4+</span>.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Availability of Service</h3>
                                    <p>
                                    Selzor strives to ensure continuous service availability during your subscription period.
                                    Scheduled maintenance may occur at off-peak hours. While Selzor will attempt to notify you
                                    in advance, it is not responsible for any loss or damage (financial or otherwise) due to
                                    downtime, data loss, or interruptions beyond our control. In such cases, subscription time
                                    may be extended.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Obligations & Responsibilities</h3>
                                    <p>
                                    You must not decompile, reverse-engineer, plagiarize, or attempt to obtain the source code
                                    of the service. You are responsible for keeping your credentials secure. Selzor does not
                                    guarantee the quality, accuracy, or legality of your submitted data. The platform is
                                    licensed-not sold-to you. You must not tarnish Selzor’s brand or that of its suppliers.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Use of Name & Logo</h3>
                                    <p>
                                    While licensed to use the service, you may identify yourself as a Selzor customer. Do not
                                    use the Selzor name or logo beyond that without prior written permission.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Promotional Material & Publicity</h3>
                                    <p>
                                    You grant Selzor permission to use your name, company name, and logos in promotional
                                    materials and case studies. To opt out, contact us at{' '}
                                    <span className="font-semibold">support@selzor.com</span>.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Price Changes</h3>
                                    <p>
                                    Selzor reserves the right to modify pricing at any time. Updated prices will be displayed
                                    on the official website or within the app.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Right to Refuse Access</h3>
                                    <p>
                                    Selzor may deny access to the service to any user, for any or no reason, at its sole
                                    discretion.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Termination of Service</h3>
                                    <p>
                                    Selzor may terminate accounts that violate these Terms. Dormant or unused accounts may be
                                    deleted, with notice provided where applicable.
                                    </p>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-500 italic">
                                        Last updated:{' '}
                                        <span className="font-semibold">
                                            {new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric', })}
                                        </span>
                                        </p>
                                </div>
                                </div>
                            </div>
                        )}


                        {activeTab === 'Disclaimer' && (
                            <div className="text-justify mt-8">
                                <h2 className="text-2xl font-semibold text-gray-600 mb-4 text-start">
                                Disclaimer
                                </h2>

                                <div className="space-y-4 text-gray-700 leading-relaxed">
                                <p>
                                    The <span className="font-bold">Selzor service</span>, access to the service, the
                                    information contained on the service, and the site are provided on an{' '}
                                    <span className="font-semibold">“As-Is” and “As-Available” basis</span> without any warranty
                                    of any kind.
                                </p>

                                <div>
                                    <p className="font-semibold mb-2">Selzor makes no warranty that:</p>
                                    <ul className="list-disc list-inside ml-4 space-y-2">
                                    <li>
                                        the service will meet your requirements;
                                    </li>
                                    <li>
                                        the service will be uninterrupted, timely, secure, error-free, or virus-free;
                                    </li>
                                    <li>
                                        the results that may be obtained from the use of the service will be accurate or reliable;
                                    </li>
                                    <li>
                                        the quality of information obtained by you through the service will meet your expectations.
                                    </li>
                                    </ul>
                                </div>

                                <p>
                                    Use of any material downloaded or obtained through the use of the service shall be at your{' '}
                                    <span className="font-semibold">own discretion and risk</span>, and you will be solely
                                    responsible for any damage to your computer system or mobile device.
                                </p>

                                <p>
                                    <span className="font-semibold">Selzor strongly advises</span> all users to protect their login
                                    credentials and <span className="font-semibold">not share confidential information</span>{' '}
                                    with anyone to prevent misuse of their Selzor account.
                                </p>

                                <p>
                                    <span className="font-semibold">Selzor cannot be held responsible</span> for any loss or damage
                                    arising in any way from the misuse of a user’s Selzor account.
                                </p>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
            {}
            <footer className="w-full mt-16 border-t border-gray-200 pt-6 text-center text-sm text-gray-500">
                © {new Date().getFullYear()} Selzor. All rights reserved.
            </footer>
        </div>
    );
};

export default PrivacyPolicy;